<script setup lang="ts">
import { computed } from 'vue'
import Icon from './Icon.vue'
import { useI18n } from '../composables/useI18n'

const { t } = useI18n()

interface FooterLink {
  label: string
  href: string
  icon: 'github' | 'book-open' | 'box' | 'mcp' | 'shield'
}

const links = computed<FooterLink[]>(() => [
  { label: t('footer.links.github') as string, href: 'https://github.com/Wolido/OpenAaaS', icon: 'github' },
  { label: t('footer.links.paper') as string, href: 'https://arxiv.org/abs/2605.13618', icon: 'book-open' },
  { label: t('footer.links.pypi') as string, href: 'https://pypi.org/project/pyopenaaas/', icon: 'box' },
  { label: t('footer.links.mcp') as string, href: 'https://pypi.org/project/openaaas-mcp-adapter/', icon: 'mcp' },
  { label: t('footer.links.license') as string, href: 'https://opensource.org/licenses/MIT', icon: 'shield' },
])
</script>

<template>
  <footer class="footer footer-center bg-base-200 text-base-content p-10 border-t border-base-300">
    <div class="max-w-6xl mx-auto">
      <div class="flex items-center justify-center gap-2 mb-4">
        <img src="/logo.png" :alt="t('footer.logoAlt')" class="h-8 w-auto" />
        <span class="font-bold text-lg">OpenAaaS</span>
      </div>

      <nav class="grid grid-flow-col gap-6 mb-4">
        <a
          v-for="link in links"
          :key="link.label"
          :href="link.href"
          target="_blank"
          rel="noopener noreferrer"
          class="link link-hover flex items-center gap-1"
        >
          <Icon :name="link.icon" iconClass="w-4 h-4" />
          {{ link.label }}
        </a>
      </nav>

      <p class="text-sm text-base-content/60">
        {{ t('footer.copyright') }}
      </p>
      <div class="flex flex-wrap justify-center items-center gap-4 text-sm text-base-content/60 mt-2">
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002019916" target="_blank" rel="noopener noreferrer" class="link link-hover inline-flex items-center gap-1">
          <img src="/ICP.png" alt="公安备案图标" class="w-4 h-4" />
          浙公网安备33011002019916号
        </a>
        <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" class="link link-hover">
          浙ICP备2025195517号-2
        </a>
      </div>
    </div>
  </footer>
</template>
